module.exports = __webpack_public_path__ + "static/mysafety-cover-illustration-v2-6fe962e27b891aa54caf8fbda04e67c9.png";